import { render, staticRenderFns } from "./PrivateAddSoleProprietorship.vue?vue&type=template&id=5c54cc20&scoped=true"
import script from "./PrivateAddSoleProprietorship.vue?vue&type=script&lang=js"
export * from "./PrivateAddSoleProprietorship.vue?vue&type=script&lang=js"
import style0 from "./PrivateAddSoleProprietorship.vue?vue&type=style&index=0&id=5c54cc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54cc20",
  null
  
)

export default component.exports